<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'ROLES', url: '/admin/roles' },
    { label: 'UPDATE_ROLE' }
  ]"
></breadcrumbs>
<page-header title="UPDATE_ROLE"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="NAME">{{
        'NAME' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['name'])"
          [ngClass]="{ 'is-danger': hasError('name') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('name')">
        {{ getError('name') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="TITLE">{{
        'TITLE' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="title"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['title'])"
          [ngClass]="{ 'is-danger': hasError('title') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('title')">
        {{ getError('title') }}
      </p>
    </div>

    <div class="field permissions">
      <label class="label" translationEditableDirective="PERMISSIONS">{{
        'PERMISSIONS' | translate
      }}</label>
      <div class="permission_group">
        <div *ngFor="let permissionGroup of permissionGroups">
          <h6
            [translationEditableDirective]="permissionGroup.translationKey"
            [translationEditableDirectiveDefault]="permissionGroup.title"
          >
            {{
              permissionGroup.translationKey
                | translate : { defaultValue: permissionGroup.title }
            }}
          </h6>
          <div class="chips">
            <chip
              [checked]="getField(['permissions']).includes(permission.name)"
              (onChange)="checkboxChange($event)"
              [value]="permission.name"
              *ngFor="let permission of permissionGroup.permissions"
            >
              <span
                [translationEditableDirective]="permission.name"
                [translationEditableDirectiveDefault]="permission.title"
              >
                {{
                  permission.name
                    | translate : { defaultValue: permission.title }
                }}
              </span>
            </chip>
          </div>
        </div>
      </div>
    </div>
  </form>
</card>

<div class="field is-grouped mx-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="onSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/roles']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
